module.exports = __webpack_public_path__ + "img/ymc-thumb4.9c7acbcf.png";